import React from 'react';
import styles from './Spacer.module.scss';

const Spacer: React.FC = () => <hr className={styles.spacer} />;

export default Spacer;
